export default __webpack_public_path__ + "static/media/6.255810ff.mp3";